/**
 *
 *    DD TO / UPDATE / DELETE FROM CART
 *    Contains all functions needed to add, update or delete a product from the cart
 *
 */
var $ = jquery;

// Add item to shopping cart with check on stock
function AddToCart(objButton, blnShowAddToCartQtyField, blnRemoveDecimals, blnPopup) {
    $(objButton).click(function () {
        if ($(this).hasClass('in-cart')) {
            if (parent) {
                parent.window.location.href = parent.window.strCartUrl
            } else {
                window.location.href = window.strCartUrl;
            }
            return false;
        }
        var blnPopUpClick = blnPopup;
        var objButton = $(this);
        var objForm = $(this).parents('form:first');
        // When there has to be checked on stock
        if (WebsiteSettingBlnCheckStockAddCart && WebsiteSettingBlnUseStock && WebsiteSettingIntProductStockType == 2) {
            // Check whether there's enough stock of this product

            // Hide previous error (if needed)
            $(objForm).find('div.stock-error').remove();

            //var objButton = $(this);
            if ($(objForm).find('input[name=\'txtQuantity\']').length) {
                var intQuantity = $(objForm).find('input[name=\'txtQuantity\']').val();
            } else {
                var intQuantity = $(objForm).find('input[name=\'hdnQuantity\']').val();
            }

            let postParams = {
                'intArticleNo': $(objForm).find('input[name=\'hdnArticleNo\']').val(),
                'intPriceNo': $(objForm).find('input[name=\'hdnPriceNo\']').val(),
                'intQuantity': intQuantity,
            };

            // Check stock from product
            $.post(strAjaxPath + 'cart/check-stock.php', $.param(postParams), function (data) {
                if (!objButton.hasClass('just-added')) {

                    objButton.addClass('just-added');
                    // Dor not remove!!! User has to be able to add multiple items
                    setTimeout(function () {
                        objButton.removeClass("just-added");
                    }, 1000);

                    data = eval('(' + data + ')');

                    if (data.value == 0) {
                        // Not enough stock => show error
                        var objDivStockError = $('<div class=\'text-danger show\'></div>');
                        objDivStockError.html(data.message);
                        $(objForm).append(objDivStockError);
                    } else {
                        // Enough stock => add product(s) to cart
                        if ($('input[name="hdnHrefPopupProductExtras"]', objForm).length) {
                            // Show extra product popup first if required
                            showExtraProductsPopup(objForm);
                        } else {
                            AddProductToCart(objForm, objButton, blnShowAddToCartQtyField, true, blnPopUpClick);
                        }
                    }
                }
            });
        } else {
            // No check on stock => add product to cart
            //AddProductToCart(objForm, objButton, blnShowAddToCartQtyField, true, blnPopUpClick);
        }

        return false;
    });

    // Handle price calculation for extra products
    $("input[name='extraproducts[]']").on('change', function(e) {
        CalculateExtraProductPrice();
    });

    CalculateExtraProductPrice();
}


function showExtraProductsPopup(objForm) {
    // Show popup
    var strHrefPopupProductExtras = $(objForm).find('input[name=\'hdnHrefPopupProductExtras\']').val();
    var objA = $('<a data-fancybox=\'iframe\' data-src=\'' + strHrefPopupProductExtras + '\'  data-type=\'iframe\' href=\'javascript:;\'></a>');

    objA.fancybox({
        iframe: {
            preload: false,
            fitToView: false,

            css: {
                height: '100%',
                width: '100%',
                maxWidth: '500px',
            },
        },
        afterClose: function () {
            objA.remove();
        },
    });

    objA.click();
}


function CalculateExtraProductPrice() {
    let total = 0;
    let $inputs = $("input[name='extraproducts[]']:checked");
    $inputs.each(function(index, input) {
        total += parseFloat($(input).attr('data-article-price'));
    });

    $('[data-extras-price]').html(total.toLocaleString('nl-BE', {style: 'currency', currency: 'EUR'}));
}


// Add item to shopping cart
function AddProductToCart(objForm, objButton, blnShowAddToCartQtyField, blnRemoveDecimals, blnPopup, strParams) {

    objButton.find('i[class*="circle"]').addClass('text-success');
    objButton.find('i[class*="circle"]').removeClass('text-primary');
    objButton.find('i[class*="shopping"]').addClass('d-none');
    objButton.find('i[class*="check"]').addClass('d-none');
    objButton.find('i[class*="spinner"]').removeClass('d-none');

    // Initialise if the quantity has to be rounded on 0 decimals (after the comma)
    if (typeof blnRemoveDecimals == 'undefined' || blnRemoveDecimals == '') {
        blnRemoveDecimals = true;
    }

    if (typeof strParams == 'undefined') {
        strParams = '';
    }

    // There is no quantity field or it doesn't have to be checked
    var blnAddZero = false;
    // Check on quantity = 0 (if needed)
    if (blnShowAddToCartQtyField) {
        // Hide previous error (if needed)
        $(objForm).find('div.quantity-error').remove();
        var blnAddZero = true;
        $(objForm).find('input[name=\'txtQuantity\']').each(function () {
            if ($(this).val() > 0) {
                blnAddZero = false;
            }
        });
        if (blnAddZero) {
            // Show error when they try to add 0 items
            var objDivQuantityError = $('<div class=\'alert error quantity-error\'>' + lblOrderAtLeastOne + '</div>');
            $(objForm).append(objDivQuantityError);
        }
    } else {
        // There is no quantity field or it doesn't have to be checked
        var blnAddZero = false;
    }

    if (!blnAddZero) {
        // Ensure that there are no decimal numbers added (if necessary)
        if (blnShowAddToCartQtyField && blnRemoveDecimals) {
            $(objButton).parent().find('input[name=\'txtQuantity\']').each(function () {
                $(this).val(Math.ceil($(this).val()));
            });
        }

        // Check if no params were given with the function
        if (strParams == '') {
            // Make strParams
            if ($(objForm).find('input[name=\'txtQuantity\']').length) {
                intQuantity = $(objForm).find('input[name=\'txtQuantity\']').val();
            } else {
                intQuantity = $(objForm).find('input[name=\'hdnQuantity\']').val();
            }
            strParams = 'intArticleNo=' + $(objForm).find('input[name=\'hdnArticleNo\']').val() + '&intPriceNo=' + $(objForm).find('input[name=\'hdnPriceNo\']').val() + '&intQuantity=' + intQuantity;
        }

        // Add extra (sub)products
        let extraProducts = [];
        $extraProductsInputs = $(objForm).find('[name="extraproducts\[\]"]:checked');
        $extraProductsInputs.each(function(index,input) {
            let inputVal = $(input).val();
            let intArticleNo = parseInt(inputVal.split('-')[0]);
            let intPriceNo = parseInt(inputVal.split('-')[1]);

            extraProducts.push({
                'articleno': intArticleNo,
                'priceno': intPriceNo,
                'quantity': intQuantity
            });
        });
        if (extraProducts.length) {
            strParams = $.param({'arrExtraProducts': extraProducts}) + '&' + strParams;
        }

        // Add items to cart
        $.post(strAjaxPath + 'cart/cart.php', strParams, function (data) {
            // Product was added to cart
            // Open 'Product added' popup
            if (blnPopup) {
                parent.$.fancybox.close();

                var strHrefPopupProductAdded = $(objForm).find('input[name=\'hdnHrefPopupProductAdded\']').val();

                parent.$.fancybox.open([{
                    type: 'iframe',
                    src: strHrefPopupProductAdded,
                    iframe: {
                        preload: false,
                        fitToView: false,

                        css: {
                            height: '100%',
                            width: '100%',
                            maxWidth: '500px',
                        },
                    }
                }]);

                //return false;
            } else {
                var objBtnParent = objButton.parents('.overview-item');
                var objParentImg = objBtnParent.find('img');
                var objMinicart = $('#mini-cart-container');

                if (objParentImg.length > 0) {
                    var imgclone = objParentImg.clone()
                        .offset({
                            top: objParentImg.offset().top,
                            left: objParentImg.offset().left,
                        })
                        .removeClass('w-100')
                        .css({
                            'opacity': '0.75',
                            'position': 'absolute',
                            'height': 'auto',
                            'width': '50px',
                            'z-index': '100',
                        })
                        .appendTo($('body'))
                        .animate({
                            'top': objMinicart.offset().top + 15,
                            'left': objMinicart.offset().left + 40,
                            'width': 50,
                            'height': 'auto',
                        }, 1000);

                    imgclone.animate({
                        'width': 0,
                        'height': 0,
                    }, function () {
                        $(this).detach();
                    });
                }
            }


            objButton.find('i[class*="spinner"]').addClass('d-none');
            objButton.find('i[class*="check"]').removeClass('d-none');
            objButton.addClass('in-cart');


            objButton.tooltip('show');
            objButton.tooltip({
                placement: 'top',
                title: objButton.attr('data-title'),
                trigger: 'manual',
            });

            setTimeout(function () {
                    objButton.tooltip('hide');
                },
                3000);


            // Update mini cart in pagehead
            UpdateMiniCart();
            return false;

        }, 'json');
    }
}

// Update mini cart in pagehead
function UpdateMiniCart() {
    $.post(strAjaxPath + 'cart/mini-cart.php', '', function (data) {
        //$("div#mini-cart-container").html(data);
        $('div#mini-cart-container').replaceWith(data);
    }, 'html');
}

// Update quantity in cart
function CartUpdateCart(objInput, blnCheckStock, blnMemberDiscount) {
    if (typeof blnCheckStock === 'undefined') {
        blnCheckStock = false;
    }

    // CUSTOM: memberdiscount
    if (typeof blnMemberDiscount === 'undefined') {
        blnMemberDiscount = false;
    }

    // Ensure that there are no decimal numbers added (if necessary)
    objInput.val(Math.ceil(objInput.val()));
    var objForm = objInput.parents('form:first');

    // Get articleno and priceno from id from input field
    var strQtyId = objInput.attr('id');
    var arrQtyId = strQtyId.split('_');
    var intArticleNo = arrQtyId[1];
    var intPriceNo = arrQtyId[2];
    var intQuantity = objInput.val();

    if (blnCheckStock) {
        // Check stock (if needed)

        // Hide previous error (if needed)
        $('form#frmCartTable').find('div.stock-error').remove();

        var strSelQtyId = strQtyId.replace('qty', 'selQty');
        // var strOldQtyId = strQtyId.replace("qty", "hdnOldQty");

        if (intArticleNo > 0 && intPriceNo > 0) {
            // Check stock via ajax
            let postParams = {
                intArticleNo: intArticleNo,
                intPriceNo: intPriceNo,
                intQuantity: intQuantity,
                strType: 'cart',
            };

            $.post(strAjaxPath + 'cart/check-stock.php', $.param(postParams), function (data) {
                data = eval('(' + data + ')');
                if (data.value == 1) {
                    // To remember the original quantity
                    // $("#" + strOldQtyId).val(objInput.val());

                    // Update cart
                    UpdateCart(intArticleNo, intPriceNo, intQuantity, blnMemberDiscount);

                } else {
                    // Show error
                    // var objDivStockError = $("<div class='font-small text-color-danger mt-2 bg-color-light text-left stock-error'></div>");
                    // objDivStockError.html(data.message);
                    // objInput.parent().append(objDivStockError);

                    var objDivStockError2 = $('<div class=\'alert alert-danger mb-2\'></div>');
                    objDivStockError2.html(data.messagecart);
                    $('form#frmCartTable').prepend(objDivStockError2);

                    // Change quantity to quantity on stock
                    $('#' + strQtyId).val(data.stock);
                    $('#' + strSelQtyId).val(data.stock);

                    // Update cart
                    UpdateCart(intArticleNo, intPriceNo, data.stock, blnMemberDiscount);

                    // Reset value to old value
                    // $("#" + strQtyId).val($("#" + strOldQtyId).val());
                    // $("#" + strSelQtyId).val($("#" + strOldQtyId).val());
                }

                return false;
            });
        }
    } else {
        UpdateCart(intArticleNo, intPriceNo, intQuantity, blnMemberDiscount);
    }
}

// Update cart (in cart-table) (the updating itself, no checks)
function UpdateCart(intArticleNo, intPriceNo, intQuantity, blnMemberDiscount) {
    // CUSTOM: memberdiscount
    if (typeof blnMemberDiscount === 'undefined') {
        blnMemberDiscount = false;
    }
    if (intArticleNo > 0 && intPriceNo > 0 && intQuantity >= 0) {
        $.post(strAjaxPath + 'cart/cart.php', 'intArticleNo=' + intArticleNo + '&intPriceNo=' + intPriceNo + '&intQuantity=' + intQuantity + '&strAction=update', function (arrData) {

            if (WebsiteSettingBlnShowVatSeparatelyInCart) {
                // VAT is a seperate rule in cart-total table

                // Update subtotal
                $('span#cart-subtotal-price').html(arrData['cartprice']['subtotalexclvat']);

                // Update vat total
                $('span#cart-vat-price').html(arrData['cartprice']['vat']);

                // Update transport
                $('span#cart-transport-price').html(arrData['cartprice']['transportexcl']);
            } else {
                // All totals/subtotals are shown incl. VAT in cart

                // Update subtotal
                $('span#cart-subtotal-price').html(arrData['cartprice']['subtotalinclvat']);

                // Update transport
                $('span#cart-transport-price').html(arrData['cartprice']['transport']);
                $.each(arrData['cartprice']['transportinfo'], function (strPreorder, arrCart) {
                    if ($('div#transport-' + strPreorder).length > 0) {
                        $('div#transport-' + strPreorder).html(arrCart.transport);
                    }
                });
            }

            // Remove all discount lines
            $('tr#cart-discount').remove();
            if (arrData['cartprice']['discount'] != '') {
                // Add discount lines
                $.each(arrData['cartprice']['discount'], function (intKey, arrDiscountLine) {
                    var objTrDiscount = $('<tr id=\'cart-discount\'></tr>');
                    var objTdDiscountLabel = $('<td></td>');
                    objTdDiscountLabel.html(arrDiscountLine['label']);
                    var objTdDiscountPrice = $('<td></td>');
                    objTdDiscountPrice.html(arrDiscountLine['price']);
                    objTrDiscount.append(objTdDiscountLabel);
                    objTrDiscount.append(objTdDiscountPrice);
                    $('tr#cart-subtotal').after(objTrDiscount);
                });
            }

            // Update total
            $('span#cart-total-price').html(arrData['cartprice']['total']);

            // Remove all giftcard lines
            $('tr#cart-giftcard').remove();
            if (arrData['cartprice']['giftcards'] != '') {
                // Add giftcard lines
                $.each(arrData['cartprice']['giftcards'], function (intKey, arrGiftcardLine) {
                    var objTrGiftcard = $('<tr id=\'cart-giftcard\'></tr>');
                    var objTdGiftcardLabel = $('<td class=\'first\'></td>');
                    objTdGiftcardLabel.html(arrGiftcardLine['label']);
                    var objTdGiftcardPrice = $('<td></td>');
                    objTdGiftcardPrice.html(arrGiftcardLine['price']);
                    objTrGiftcard.append(objTdGiftcardLabel);
                    objTrGiftcard.append(objTdGiftcardPrice);
                    $('tr#total-before-giftcards').after(objTrGiftcard);
                });

                // Update total after discount
                $('tr#cart-total span#cart-price-total').html(arrData['cartprice']['total_after_discount']);

                // Make it able that you can remove the giftcard
                //RemoveGiftCardCode();
            }

            // Update subtotals per product line
            $.each(arrData['cart'], function (intKey, arrCartLine) {
                if (WebsiteSettingBlnShowVatSeparatelyInCart) {
                    // VAT is a seperate rule in cart-total table

                    // Update subtotal for product line
                    $('span#subtotal_' + arrCartLine['articleno'] + '_' + arrCartLine['priceno']).html(arrCartLine['price'][arrCartLine['priceno']]['subtotalexcl']);
                } else {
                    // All totals/subtotals are shown incl. VAT in cart

                    // Update subtotal for product line
                    $('span#subtotal_' + arrCartLine['articleno'] + '_' + arrCartLine['priceno']).html(arrCartLine['price'][arrCartLine['priceno']]['subtotal']);

                    // CUSTOM: check if member discount
                    if (blnMemberDiscount && (typeof arrCartLine['memberdiscount'] !== 'undefined')) {
                        // Update member discount for product line
                        $('span#memberdiscount_' + arrCartLine['articleno'] + '_' + arrCartLine['priceno']).html(arrCartLine['memberdiscount']);
                    }
                }

                // Update quantity fields too (might have changed ie: main product quantity changed the extra products quantity)
                $('#selQty_' + arrCartLine['articleno'] + '_' + arrCartLine['priceno'] + '_0').val(arrCartLine['quantity']);
            });


        }, 'json');
    }
}

// Remove item from cart
function RemoveFromCart(intCartKey) {
    var arrCartKey = [];
    if (intCartKey == "all") {
        $("a.delete").each(function () {
            var intKey = $(this).data('key');
            if (intKey != "all" && intKey > 0) {
                arrCartKey.push(intKey);
            }
        });
    } else {
        arrCartKey.push(intCartKey);
    }

    strParams = 'strCartKey=' + arrCartKey.join() + '&strAction=delete';
    $.post(strAjaxPath + 'cart/cart.php', strParams, function (data) {
        // Reload page
        document.location.reload();
    }, 'json');
}

// Add a wallet value to the cart
function AddWalletToCart(strHrefPopupProductWalletAdded){
    // Click on 'Add' button to add a value to the wallet
    $('#btnAddValueToWallet').click(function(){
        $.post(strAjaxPath + 'customerzone/add-wallet-to-cart.php', 'value=' + $('#txtWalletValue').val(), function (data) {
            // Show popup
            var objA = $('<a data-fancybox=\'iframe\' data-src=\'' + strHrefPopupProductWalletAdded + '\'  data-type=\'iframe\' href=\'javascript:;\'></a>');

            // Open 'Product added' popup
            objA.fancybox({
                iframe: {
                    preload: false,
                    fitToView: false,

                    css: {
                        height: '100%',
                        width: '100%',
                        maxWidth: '500px',
                    },
                },
                afterClose: function () {
                    objA.remove();
                },
            });

            objA.click();
        }, 'text');
    });

    // Only allow numeric values in value field for wallet
    $('#txtWalletValue').blur(function(){
        this.value = Math.abs(this.value);
    });
}


window.AddToCart = AddToCart;
window.UpdateMiniCart = UpdateMiniCart;
window.RemoveFromCart = RemoveFromCart;
window.UpdateCart = UpdateCart;
window.CartUpdateCart = CartUpdateCart;
window.AddProductToCart = AddProductToCart;
window.AddWalletToCart = AddWalletToCart;